module.exports = __webpack_public_path__ + "static/acon-fdf58fae7ec036614b8cf864f017c3d9.png";